import { Calendar } from "@assets/components/ui/calendar";
import { Button } from "@components/button";
import { FlexLoader } from "@components/loader";
import { Modal } from "@components/modal";
import { CustomSelect } from "@components/select";
import { useGeneral } from "@features/general";
import { OrderCSVRequest } from "@features/general/api";
import { useState } from "react";
import { DateRange } from "react-day-picker";
import { useForm } from "react-hook-form";

type Props = {
  isModalOpen: boolean;
  hideModal: () => void;
};

export const OrderCSVModal = ({ hideModal, isModalOpen }: Props) => {
  const now = new Date();
  const ninetyDaysAgo = new Date(now.getTime() - 90 * 24 * 60 * 60 * 1000);

  const { state, getOrderCSV } = useGeneral();

  const [range, setRange] = useState<DateRange | undefined>({
    from: ninetyDaysAgo,
    to: now,
  }); // State for calendar range
  // const [errors, setErrors] = useState<string[]>([]); // Validation error messages
  const { control, handleSubmit /* reset, setValue, resetField */ } =
    useForm<OrderCSVRequest>();

  const submit = (data: OrderCSVRequest) => {
    const now = new Date();
    const ninetyDaysAgo = new Date(now.getTime() - 90 * 24 * 60 * 60 * 1000);
    data.date_start_time =
      (range?.from?.getTime() || ninetyDaysAgo.getTime()) / 1000;
    data.date_end_time = (range?.to?.getTime() || now.getTime()) / 1000;

    getOrderCSV(data).then(() => {
      hideModal();
    });
    // const validationErrors = validationRules
    //   .map((rule) => (!rule.validate(data) ? rule.message : null))
    //   .filter(Boolean) as string[];

    // if (validationErrors.length > 0) {
    //   setErrors(validationErrors);
    // } else {
    //   setErrors([]);
    //   onSubmit(data);
    //   hideModal();
    // }
  };

  return (
    <Modal isOpen={isModalOpen} onClose={hideModal} title="Создать выгрузку">
      {state.loading ? (
        <FlexLoader style={{ width: "200px", height: "200px" }} />
      ) : (
        <form>
          <div className="flex justify-center mb-[10px]">
            <Calendar range={range} setRange={setRange} max={90} />
          </div>
          <div className="flex flex-col gap-[8px] mb-[10px]">
            <span className="text-[14px] font-semibold">Статус</span>
            <CustomSelect
              name={"status"}
              control={control}
              options={statusOptions}
              placeholder={"Выберите значение"}
            />
          </div>
          <div className="flex flex-col gap-[8px] mb-[10px]">
            <span className="text-[14px] font-semibold">Тип</span>
            <CustomSelect
              name={"type"}
              control={control}
              options={typeOptions}
              placeholder={"Выберите значение"}
            />
          </div>
          {/* {errors.length > 0 && (
          <div className={styles.errorNote}>
            {errors.map((error, index) => (
              <p key={index}>{error}</p>
            ))}
          </div>
        )} */}
          <Button onClick={handleSubmit(submit)}>Готово</Button>
        </form>
      )}
    </Modal>
  );
};

const statusOptions = [
  { text: "Зачислен", value: "completed" },
  { text: "Отменен", value: "cancelled" },
  { text: "Спор открыт", value: "dispute_open" },
  { text: "В процессе", value: "pending" },
  { text: "В ожидании", value: "processing" },
];

const typeOptions = [
  { text: "Pay-in", value: "buy" },
  { text: "Pay-out", value: "sell" },
];
